import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'rsuite'
import CampaignTableComponent from '../CampaignTableComponent'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import useAuth from '../../auth/useAuth'
import {useDispatch} from "react-redux";
import {togglePortfolioAssignments} from "../../redux/actions/campaignDetail";

const AddRemoveCampaignModal = ({
  selectedPortfolio,
  onClose,
  onSave
}) => {
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth()

  const [selectedCampaigns, setSelectedCampaigns] = useState([])
  const [isLoadingCampaigns, setIsLoadingCampaigns] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => {
    setSelectedCampaigns(selectedPortfolio?.campaigns || [])
  }, [selectedPortfolio])

  const handleTableSelectionChange = (selectedIds = []) => {
    setSelectedCampaigns(selectedIds)
  }

  const handleSave = async () => {
    try {
      setIsUpdating(true)
      const accessToken = await getAccessTokenSilently()

      // Use toggle functionality to handle both adding and removing campaigns
      await dispatch(togglePortfolioAssignments(
        accessToken,
        selectedCampaigns || [],
        selectedPortfolio.portfolio_id,
        selectedPortfolio.name,
        selectedPortfolio?.campaigns || []
      ))
      onSave()
      setIsUpdating(false)
    } catch (error) {
      console.error('Error updating campaigns:', error)
      setIsUpdating(false)
    }
  }

  return (
    <>
      <Modal className="portfolio-budget-modal" backdrop="static" size="xl" show>
        <Modal.Header onHide={() => { onClose() }}>
          <Modal.Title>Add/Remove Campaigns - {selectedPortfolio?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { (isLoadingCampaigns) && <LoaderComponent /> }

          <CampaignTableComponent
            selectedCampaignIds={selectedCampaigns}
            onSelectionChange={handleTableSelectionChange}
            onLoadStart={() => setIsLoadingCampaigns(true)}
            onLoadEnd={() => setIsLoadingCampaigns(false)}
            removeSelectionOnFilterChange={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose} appearance="subtle">
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={isUpdating}
            loading={isUpdating}
            appearance="primary"
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddRemoveCampaignModal
